import { Link } from "react-router-dom";

export const Logo = ({ className = "", onClick }) => (
  <Link
    to="/"
    onClick={onClick}
    data-testid="brand-logo"
    className={`block ${className}`}
    aria-label="Jamie M Rapavy — Coaching, Connecting, Clarifying"
  >
    <img
      src="/jamie-logo.png"
      alt="Jamie M Rapavy — Coaching · Connecting · Clarifying"
      className="h-14 sm:h-16 w-auto transition-opacity hover:opacity-80"
    />
  </Link>
);
